<template>
  <div id="app" class="container">
    <div class = "headers">
      <h1><router-link to="/">Gregory Ristow</router-link></h1>
      <h2 v-if="$route.name === 'Contents'">
        <router-link to="/">Application for Tenure</router-link>
      </h2>
    </div>
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'App',
};
</script>

<style>
html {
  height: 100%;
}
body {
  height: 100%;
  margin: auto;
  background-color: #CCCCCC;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;

  color: #333333;
}

.headers {
  padding: 25px 25px 5px 25px;
}
.container {
  max-width: 800px;
  /* padding: 25px; */
  margin: auto;
  background-color: #FCFCFC;
  /* min-height: 100%; */
  height: 100%;
}

.content {
  line-height: 1.4;
  min-height: 100%;
  margin-top: 25px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 20px;
  background-color: #FCFCFC;
}

.content a {
  color: #33A;
  text-decoration: underline;
  cursor: pointer;
}

.pdf-content {
  height: 110%;
}

h1 {
  margin: 0 0;
}
h1>a {
  text-decoration: none;
  color: #333333;
}
h2 {
  margin: 0 0;
}
h2>a {
  text-decoration: none;
  color: #333333;
}
h3 {
  margin-top: 30px;
}

.publications li {
  padding-bottom: 18px;
}

.footer {
   display: flex;
   justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/App.vue